import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

import { formatOperationType } from './format-operation-type';

interface ActionDataParsed {
  description?: string;
  operationType?: string;
  fieldsModified?: string[];
  assetCount?: number;
}

@Component({
  selector: 'lib-action-data-cell-renderer',
  standalone: true,
  imports: [MatTooltipModule],
  template: `
    @if (displayText) {
      <span
        class="action-data-text"
        [matTooltip]="tooltipText"
        matTooltipPosition="above"
      >{{ displayText }}</span>
    } @else {
      <span class="action-data-empty">—</span>
    }
  `,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        height: 100%;
        overflow: hidden;
      }
      .action-data-text {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .action-data-empty {
        color: #9ca3af;
      }
    `,
  ],
})
export class ActionDataCellRendererComponent
  implements ICellRendererAngularComp
{
  displayText = '';
  tooltipText = '';

  agInit(params: ICellRendererParams): void {
    this.parseActionData(params.value);
  }

  refresh(params: ICellRendererParams): boolean {
    this.parseActionData(params.value);
    return true;
  }

  private parseActionData(value: unknown): void {
    if (!value || typeof value !== 'string') {
      this.displayText = '';
      this.tooltipText = '';
      return;
    }
    try {
      const parsed = JSON.parse(value) as ActionDataParsed;

      if (parsed.description) {
        this.displayText = parsed.description;
        this.tooltipText = parsed.description;
        return;
      }

      if (parsed.operationType) {
        const opLabel = formatOperationType(parsed.operationType);
        const fields = parsed.fieldsModified ?? [];
        const count = parsed.assetCount;

        const parts: string[] = [opLabel];
        if (count != null) {
          parts.push(`${count} asset${count !== 1 ? 's' : ''}`);
        }

        this.displayText = parts.join(' · ');
        this.tooltipText = fields.length
          ? `${opLabel}\nFields: ${fields.join(', ')}${count != null ? `\nAssets: ${count}` : ''}`
          : this.displayText;
        return;
      }

      this.displayText = '';
      this.tooltipText = '';
    } catch {
      this.displayText = '';
      this.tooltipText = '';
    }
  }
}
